import { Form, Formik } from 'formik';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../../../actions/userProfileActions';
import ISettingsViewModel from '../../../../interfaces/umbracoNodes/settingsViewModel';
import Button from '../../../base/button/button';
import FormikCheckbox from '../../../base/forms/formikCheckbox';
import FormikFieldWrapper from '../../../base/forms/formikFieldWrapper';
import { Column, Columns } from '../../../base/grid';
import { A, H2 } from '../../../base/typography';
import * as StyledOnboarding from '../onboarding.styles';
import { stepNotificationsInitialValues, stepNotificationsSchema } from './stepNotifications.schema';

interface Props {
	Proceed: any;
}

const StepNotifications: FC<Props> = ({ Proceed }) => {
	const { t } = useTranslation('myShipments');
	const { settings }: { settings: ISettingsViewModel } = useSelector(
		(state: { pageReducer: { settings: ISettingsViewModel } }) => state.pageReducer
	);
	const dispatch = useDispatch<any>();
	return (
		<StyledOnboarding.LeftColumn>
			<Formik
				initialValues={stepNotificationsInitialValues}
				enableReinitialize
				validationSchema={stepNotificationsSchema}
				onSubmit={Proceed}>
				{({ setFieldValue, isSubmitting }) => (
					<Form>
						<H2>{t('onboarding.terms.heading')}</H2>

						<Columns>
							<Column>
								<StyledOnboarding.InfoText checkbox>
									{t('onboarding.terms.terms1')}
									<A href={settings.Values.Terms.Url} target="_blank">
										{t('onboarding.terms.terms2')}
									</A>
									{t('onboarding.terms.terms3')}
								</StyledOnboarding.InfoText>
								<FormikFieldWrapper name="terms" languageComponent="myShipments">
									<FormikCheckbox
										id="terms"
										name="terms"
										label={t('onboarding.terms.termsCheckbox') as string}
										setFieldValue={setFieldValue}
									/>
								</FormikFieldWrapper>
							</Column>
						</Columns>

						<Button primary type="submit" isLoading={isSubmitting}>
							{t('onboarding.next')}
						</Button>

						<StyledOnboarding.SkipLink onClick={() => dispatch(logout())} logout>
							{t('navigation.logout')}
						</StyledOnboarding.SkipLink>
					</Form>
				)}
			</Formik>
		</StyledOnboarding.LeftColumn>
	);
};
export default StepNotifications;
